import * as API from '@/services/api';
import { message } from 'antd';

export default {
    namespace: 'company',
    state: {
        companyList: [],
        comInfo: {}
    },
    effects: {
        *getCompanyList({ payload }, { call, put }) {
            const res = yield call(API.getCompanyList, { ...payload });
            if (res.code === 0) {
                const data = res.data;
                yield put({
                    type: 'save',
                    payload: {
                        companyList: data,
                    }
                })
            }
        },
        *addCompany({ payload }, { call, put }) {
            const res = yield call(API.addCompany, payload);
            if (res.code === 0) {
                message.success('OK');
                yield put({
                    type: 'getCompanyList'
                })
            } else {
                message.error(res.message)
            }
        },
        *editCompany({ payload }, { call, put }) {
            const res = yield call(API.editCompany, payload);
            if (res.code === 0) {
                message.success('OK');
                yield put({
                    type: 'getCompanyList'
                })
                yield put({
                    type: 'save',
                    payload: {comInfo: res.data}
                })
            } else {
                message.error(res.message)
            }
        },
        *delCompany({ payload }, { call, put }) {
            const res = yield call(API.delCompany, payload);
            if (res.code === 0) {
                message.success('OK');
                yield put({
                    type: 'getCompanyList'
                })
            } else {
                message.error(res.message)
            }
        },
    },
    reducers: {
        save(state, action) {
            return {
                ...state,
                ...action.payload,
            };
        },
    },
}